module.exports = __webpack_public_path__ + "static/media/image_prd_3.a9b2cc34.png";